import { createRouter, createWebHistory } from 'vue-router';
import { VueCookieNext } from 'vue-cookie-next';
import LoginIndex from '@/views/login/LoginIndex.vue';
import NotificationIndex from '@/views/notification/vue/NotificationIndex.vue';
import NotificationDetail from '@/views/notification/vue/NotificationDetail.vue';
import CompAccountIndex from '@/views/account/vue/CompAccountIndex.vue';
import CompAccountInfo from '@/views/account/vue/CompAccountInfo.vue';
import CompAccountPassword from '@/views/account/vue/CompAccountPassword.vue';
import CompAccountSettings from '@/views/account/vue/CompAccountSettings.vue';
import CompAccountEmailVerifySendCompleted from '@/views/account/vue/CompAccountEmailVerifySendCompleted.vue';
import CompEstimateIndex from '@/views/estimate/vue/CompEstimateIndex.vue';
import CompEstimateInput from '@/views/estimate/vue/CompEstimateInput.vue';
import CompEstimateConfirm from '@/views/estimate/vue/CompEstimateConfirm.vue';
import CompEstimateCompleted from '@/views/estimate/vue/CompEstimateCompleted.vue';
import RegistrationIndex from '@/views/registration/RegistrationIndex.vue';
import CompTx from '@/views/tx/vue/CompTx.vue';
import CompTxSummary from '@/views/tx/vue/CompTxSummary.vue';
import CompTxEstimate from '@/views/tx/vue/CompTxEstimate.vue';
import CompPasswordResetIndex from '@/views/password/vue/CompPasswordResetIndex.vue';
import CompPasswordResetRequest from '@/views/password/vue/CompPasswordResetRequest.vue';
import CompPasswordReset from '@/views/password/vue/CompPasswordReset.vue';
import CompTopIndex from '@/views/top/vue/CompTopIndex.vue';
import CompCompanyIndex from '@/views/company/vue/CompCompanyIndex.vue';
import CompServiceIndex from '@/views/service/vue/CompServiceIndex.vue';
import Comp404 from '@/views/404/vue/Comp404.vue';
import routerTmp from '@/router/routerTmp/routerTmp.js';
import CompTxSelectApplication from '@/views/tx/vue/CompTxSelectApplication';
import UrlExpired from '@/views/expired/vue/UrlExpired.vue';
import Maintenance from '@/views/maintenance/vue/Maintenance.vue';

const routes = [
  routerTmp[0],
  routerTmp[1],
  routerTmp[2],
  {
    path: '/',
    name: 'Root',
    redirect: { name: 'Login' },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginIndex,
    meta: {
      isPublic: true,
      showFooter: true,
      headerType: 'simple',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ ログイン',
    },
  },
  {
    path: '/tx-select',
    name: 'TxSelectIndex',
    beforeEnter() {
      window.location = process.env.VUE_APP_NEW_NEXT_DOMAIN + '/tx';
    },
  },
  {
    path: '/tx-select/:selectId',
    name: 'TxSelect',
    component: CompTx,
    props: true,
    children: [
      {
        path: 'summary',
        name: 'TxSelectSummary',
        component: CompTxSummary,
        props: true,
        meta: {
          isTxSelectSummary: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          isSpHideHeader: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 案件一覧 / 依頼概要',
        },
      },
      {
        path: 'company',
        name: 'TxSelectCompany',
        redirect: { name: 'TxSelectSummary' },
      },
      {
        path: 'response',
        name: 'TxSelectResponse',
        component: CompTxEstimate,
        props: true,
        meta: {
          isTxSelectResponse: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          isSpHideHeader: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 案件一覧 / 募集回答',
        },
      },
      {
        path: 'application',
        name: 'TxSelectApplication',
        component: CompTxSelectApplication,
        props: true,
        meta: {
          isTxSelectApplication: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          isSpHideHeader: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 応募内容',
        },
      },
    ],
  },
  {
    path: '/notification/',
    name: 'NotificationIndex',
    component: NotificationIndex,
    meta: {
      headerType: 'normal',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】 / お知らせ / お知らせ一覧',
    },
  },
  {
    path: '/notification/:notificationId',
    name: 'NotificationDetail',
    component: NotificationDetail,
    props: true,
    meta: {
      headerType: 'normal',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】 / お知らせ / お知らせ詳細',
    },
  },
  {
    path: '/tx',
    name: 'TxIndex',
    beforeEnter(to) {
      let query = '';
      if (Object.keys(to.query).length > 0) {
        query = '?' + new URLSearchParams(to.query).toString();
      }

      window.location = process.env.VUE_APP_NEW_NEXT_DOMAIN + '/tx' + query;
    },
  },
  {
    path: '/tx/:id',
    name: 'Tx',
    component: CompTx,
    props: true,
    children: [
      {
        path: 'summary',
        name: 'TxSummary',
        component: CompTxSummary,
        props: true,
        meta: {
          isTxSummary: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 取引管理 / 依頼概要',
        },
      },
      {
        path: 'summary/message',
        name: 'TxSummaryMessage',
        component: CompTxSummary,
        beforeEnter(to) {
          window.location.href = `${process.env.VUE_APP_NEW_NEXT_DOMAIN}/tx/${to.params.id}/messages`;
        },
      },
      {
        path: 'company',
        name: 'TxCompany',
        redirect: { name: 'TxSummary' },
      },
      {
        path: 'company/message',
        name: 'TxCompanyMessage',
        beforeEnter(to) {
          window.location.href = `${process.env.VUE_APP_NEW_NEXT_DOMAIN}/tx/${to.params.id}/messages`;
        },
      },
      {
        path: 'application',
        name: 'TxApplication',
        component: CompTxSelectApplication,
        props: true,
        meta: {
          isTxApplication: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 取引管理 / 応募内容',
        },
      },
      {
        path: 'application/message',
        name: 'TxApplicationMessage',
        component: CompTxSelectApplication,
        beforeEnter(to) {
          window.location.href = `${process.env.VUE_APP_NEW_NEXT_DOMAIN}/tx/${to.params.id}/messages`;
        },
      },
      {
        path: 'estimate/:patternNumber',
        name: 'TxEstimate',
        component: CompTxEstimate,
        props: true,
        meta: {
          isTxEstimate: true,
          isFixed: true,
          showMessage: false,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 取引管理 / 送信した見積もり',
        },
      },
      {
        path: 'estimate/message',
        name: 'TxEstimateMessage',
        component: CompTxEstimate,
        beforeEnter(to) {
          window.location.href = `${process.env.VUE_APP_NEW_NEXT_DOMAIN}/tx/${to.params.id}/messages`;
        },
      },
    ],
  },
  {
    path: '/account',
    component: CompAccountIndex,
    children: [
      {
        path: '/account',
        name: 'AccountInfo',
        component: CompAccountInfo,
        meta: {
          isInfo: true,
          isFixed: true,
          showFooter: true,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 各種設定 / アカウント情報',
        },
      },
      {
        path: '/account/password',
        name: 'AccountPassword',
        component: CompAccountPassword,
        meta: {
          isPassword: true,
          isFixed: true,
          showFooter: true,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 各種設定 / パスワード変更',
        },
      },
      {
        path: '/account/settings',
        name: 'AccountSettings',
        component: CompAccountSettings,
        meta: {
          isSetting: true,
          isFixed: true,
          showFooter: true,
          headerType: 'normal',
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 各種設定 / 詳細設定',
        },
      },
      {
        path: '/account/notification',
        name: 'AccountNotification',
        redirect: { name: 'AccountSettings' },
      },
    ],
  },
  {
    path: '/account/email-verify/send-completed',
    name: 'AccountEmailVerifySendCompleted',
    component: CompAccountEmailVerifySendCompleted,
    meta: {
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 各種設定 / アカウント情報 /　メール / 認証メール送信完了',
      headerType: 'normal',
      isFixed: true,
      showFooter: true,
    },
  },
  {
    path: '/estimate/:transactionId/:patternNumber/',
    props: true,
    component: CompEstimateIndex,
    children: [
      {
        path: '/estimate/:transactionId/:patternNumber/',
        name: 'EstimateInput',
        props: true,
        component: CompEstimateInput,
        meta: {
          isInput: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 見積もり作成',
        },
      },
      {
        path: '/estimate/:transactionId/:patternNumber/confirm/',
        name: 'EstimateConfirm',
        props: true,
        component: CompEstimateConfirm,
        meta: {
          isConfirm: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 見積もり確認',
        },
      },
      {
        path: '/estimate/:transactionId/:patternNumber/completed/',
        name: 'EstimateCompleted',
        props: true,
        component: CompEstimateCompleted,
        meta: {
          isCompleted: true,
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 見積もり送信完了',
        },
      },
    ],
  },
  {
    path: '/register',
    name: 'Register',
    redirect: { name: 'Registration' },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: RegistrationIndex,
    meta: {
      isPublic: true,
      headerType: 'simple',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ ユーザー登録',
    },
  },
  {
    path: '/registration/completed',
    name: 'RegistrationCompleted',
    component: RegistrationIndex,
    meta: {
      isPublic: true,
      headerType: 'simple',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ ユーザー登録',
    },
  },
  {
    path: '/password/reset',
    name: 'PasswordResetIndex',
    component: CompPasswordResetIndex,
    meta: {
      isPublic: true,
      isFixed: true,
      headerType: 'simple',
    },
    children: [
      {
        path: '/password/reset/:token',
        component: CompPasswordReset,
        meta: {
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ パスワード再設定',
        },
      },
      {
        path: '/password/reset/request',
        component: CompPasswordResetRequest,
        name: 'PasswordResetRequest',
        meta: {
          title:
            '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ パスワード再設定申請',
        },
      },
    ],
  },
  {
    path: '/top',
    name: 'Top',
    component: CompTopIndex,
    meta: {
      isFixed: true,
      headerType: 'normal',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ サービス情報TOP',
    },
  },
  {
    path: '/company/:companyId',
    name: 'Company',
    component: CompCompanyIndex,
    meta: {
      isFixed: true,
      headerType: 'normal',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ 企業情報編集',
    },
  },
  {
    path: '/service/:serviceId',
    name: 'Service',
    component: CompServiceIndex,
    meta: {
      isFixed: true,
      headerType: 'normal',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】/ サービス情報編集',
    },
  },
  {
    path: '/contact/',
    name: 'Contact',
    redirect: { name: 'Login' },
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    redirect: { name: 'Login' },
  },
  {
    path: '/withdraw/completed',
    name: 'WithdrawCompleted',
    redirect: { name: 'Login' },
  },
  {
    path: '/expired/',
    name: 'UrlExpired',
    component: UrlExpired,
    meta: {
      isPublic: true,
      headerType: 'simple',
      title:
        '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】 / 有効期限切れ',
    },
  },
  {
    path: '/termspaid',
    name: 'TermsPaid',
    meta: { isPublic: true },
    beforeEnter() {
      window.location.href = 'https://www.imitsu-cloud.jp/termspaid';
    },
  },
  {
    path: '/privacypolicy',
    name: 'Privacypolicy',
    meta: { isPublic: true },
    beforeEnter() {
      window.location.href = 'https://imitsu.jp/privacypolicy';
    },
  },
  {
    path: '/maintenance/',
    name: 'Maintenance',
    component: Maintenance,
    meta: {
      isPublic: true,
      isMaintenance: true,
      title:
          '法人向け受発注システム（SaaS）の【アイミツCLOUD】 / サービス統合のお知らせ',
    },
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: Comp404,
    meta: {
      headerType: 'simple',
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: false,
  routes,
});

router.beforeEach((to, from, next) => {
  // 24/07/06 release redirect to maintenance page
  if (to.name !== 'Maintenance' && process.env.VUE_APP_IS_MAINTENANCE === 'true') {
    next({ name: 'Maintenance' });
  }
  const accessToken = VueCookieNext.getCookie('accessToken');
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title =
      '法人向け受発注システム（SaaS）の【PRONIアイミツメンバーズ】';
  }
  if (to.meta.isPublic === true) {
    next();
  } else {
    if (accessToken) {
      next();
    } else {
      window.location.href = `/login/?redirect=${encodeURIComponent(
        location.href.replace(location.origin, '')
      )}`;
    }
  }
});

export default router;
